// Text for the shared base components (step indicator, dropdowns, range fields).
// See src/components/base/. Must keep the same keys as ar/ui.ts.
const ui = {
  stepper: {
    label: 'Steps',
    counter: 'Step {{current}} of {{total}}',
    counterWithLabel: 'Step {{current}} of {{total}}: {{label}}',
    stepWithLabel: 'Step {{n}}: {{label}}, {{status}}',
    stepNoLabel: 'Step {{n}}, {{status}}',
    status: {
      completed: 'completed',
      current: 'current',
      upcoming: 'upcoming',
    },
    goTo: 'Back to step {{n}}: {{label}}',
    goToNoLabel: 'Back to step {{n}}',
  },
  combobox: {
    noResults: 'No matching results',
    loading: 'Loading…',
    clear: 'Clear',
    suggestions: 'Suggestions',
  },
  select: {
    placeholder: 'Select',
  },
  range: {
    from: 'From',
    to: 'To',
    any: 'Any',
    price: 'Price',
    priceYearly: 'Price (yearly)',
    area: 'Area',
    unitSqm: 'm²',
    minGreaterThanMax: 'Min is greater than max',
    chooseTypeHint: 'Choose a property type to filter bedrooms and bathrooms',
    customAmount: 'or type an amount',
    // Search composites (src/components/search/): a field's screen-reader name, e.g. "Bedrooms: From".
    boundLabel: '{{field}}: {{bound}}',
    customNumber: 'or type a number',
    priceMonthly: 'Price (monthly)',
    // The شهري / سنوي toggle on the rent price column.
    period: {
      label: 'Rent period',
      monthly: 'Monthly',
      yearly: 'Yearly',
    },
  },
  // City picker (CityCombobox).
  city: {
    label: 'City',
    allCities: 'All cities',
    placeholder: 'Choose a city',
  },
  // Property type picker (PropertyTypePicker).
  typePicker: {
    label: 'Property type',
    anyType: 'All types',
    showMore: 'Show more ({{count}})',
    showLess: 'Show less',
  },
};

export default ui;
